import React, { useEffect, memo, useContext, useState, Fragment } from "react";
import { _O } from "../../modules/utils";
import { NativeAction } from "../../modules/utils/HandleWs";

import { closeLayerFn, openLayerFn } from "../../views/Layout";
import { stringToTelNo } from "../../modules/utils/CheckLogic";
import {
  AppContext,
  LOG_OUT_SUCCESS,
  SocketCommand,
  socketManager,
} from "../AppProvider";
import {
  allCookieClear,
  allDelCookies,
  getCookie,
} from "../../modules/utils/cookie";
import { loginLogInterface } from "../../views/Membership/LoginOld";
import { CheckIcon, Checkbox } from "../../views/Nftf/Modal/ModalStyle";
import {
  AppleLoginSrc,
  IC,
  KakaoLoginSrc,
  NaverLoginSrc,
} from "../../resources/Assets";
import Layer from "./Layer/Layer";

// 확인 다이얼로그 [[
export const AlertLayer = memo(({ priv, title, msg, url, handleConfirmCB }) => {
  useEffect(() => {
    $(".alert-layer .tbns-area a").click(function () {
      if (url) {
        _O.Open(url);
      } else {
        closeLayerFn($(".alert-layer"));
      }
    });
  });

  return (
    <div className="blacklayer-container alert-layer" style={{ zIndex: "55" }}>
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          <div className="blgr-title">{title}</div>

          <div className="save-question-box">
            <span className="utt">
              <div dangerouslySetInnerHTML={{ __html: msg }} />
            </span>
          </div>

          <div className="tbns-area">
            <a
              href={void 0}
              className="btn-round wht"
              id="exchangeTargetLogin"
              onClick={handleConfirmCB}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});

export const AlertWait = props => {
  const { priv } = props;

  return (
    <div className="blacklayer-container alert-layer2">
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          {/* <div className="blgr-title">{title}</div> */}

          <div className="save-question-box">
            <span className="utt">
              <div>서비스 준비중 입니다.</div>
            </span>
          </div>

          <div className="tbns-area">
            <a
              className="btn-round wht"
              onClick={() => closeLayerFn($(".alert-layer2"))}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// 확인 다이얼로그 ]]

// 취소/확인 다이얼로그 [[
export const ConfirmLayer = ({
  priv,
  title,
  msg,
  handleCancelCB,
  handleConfirmCB,
}) => {
  useEffect(() => {
    $(".confirm-layer .tbns-area a").click(function () {
      closeLayerFn($(".confirm-layer"));
    });
  });

  return (
    <div className="blacklayer-container confirm-layer" id="confirm-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          <div className="blgr-title">{title}</div>

          <div className="save-question-box">
            <div dangerouslySetInnerHTML={{ __html: msg }} />
          </div>

          <div className="tbns-area">
            <a className="btn-round gray" onClick={handleCancelCB}>
              취소
            </a>
            <a
              className="btn-round wht"
              id="targetLogout"
              onClick={handleConfirmCB}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// 취소/확인 다이얼로그 ]]

export const CustomConfirmLayer = ({
  priv,
  title,
  msg,
  msg2,
  handleCancelCB,
  handleCancelCBText,
  handleConfirmCB,
  handleConfirmCBText,

  setCookieBtn,
  toggle,
  setToggle,
  textAlign,
}) => {
  useEffect(() => {
    $(".confirm-layer .tbns-area a").click(function () {
      closeLayerFn($("#cstmCnfmLayer"));
    });
  });

  return (
    <div
      className="blacklayer-container confirm-layer"
      id="cstmCnfmLayer"
      style={{ zIndex: 100 }}>
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          <div className="blgr-title">{title}</div>

          <div
            className="save-question-box"
            style={{
              textAlign: textAlign ? textAlign : "center",
              wordBreak: "keep-all",
            }}>
            <div dangerouslySetInnerHTML={{ __html: msg }} />
            <div dangerouslySetInnerHTML={{ __html: msg2 }} />
          </div>

          {setCookieBtn && setCookieBtn === true && (
            <Checkbox style={{ paddingBottom: "24px", color: "#fff" }}>
              <CheckIcon
                type="checkbox"
                style={{ border: "0px" }}
                onClick={() => setToggle(!toggle)}
              />
              더 이상 보이지 않기
            </Checkbox>
          )}

          <div className="tbns-area">
            {handleCancelCBText != null && (
              <a className="btn-round gray" onClick={handleCancelCB}>
                {handleCancelCBText}
              </a>
            )}
            <a
              className="btn-round wht"
              id="targetLogout"
              onClick={handleConfirmCB}>
              {handleConfirmCBText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AccountMergeResultLayer = ({
  priv,
  title,
  msg,
  msg2,
  handleCancelCB,
  handleCancelCBText,
  handleConfirmCB,
  handleConfirmCBText,

  setCookieBtn,
  toggle,
  setToggle,
}) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  useEffect(() => {
    $(".confirm-layer .tbns-area a").click(function () {
      closeLayerFn($("#acntMrgLayer"));
    });
  });
  return (
    <div className="blacklayer-container confirm-layer" id="acntMrgLayer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          <div className="blgr-title">{title}</div>

          <div className="save-question-box" style={{ padding: "24px 0px" }}>
            <div
              style={{ textAlign: "left", marginBottom: "8px" }}
              dangerouslySetInnerHTML={{ __html: msg }}
            />

            <div
              style={{
                display: "flex",
                padding: "16px 12px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                alignSelf: "stretch",
                borderRadius: "10px",
                background: "#FAFAFA",
              }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                }}>
                <div
                  style={{
                    color: "#333",
                    fontFamily: "Pretendard",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "20px",
                  }}>
                  통합계정정보
                </div>
                <div></div>
              </div>

              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignSelf: "stretch",
                  }}>
                  <div
                    style={{
                      color: "#888",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                    }}>
                    아이디
                  </div>
                  <div
                    style={{
                      color: "#333",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                    }}>
                    {getCookie("signUpChannel") === "000" ? (
                      getCookie("userId")
                    ) : getCookie("signUpChannel") === "100" ? (
                      <img src={NaverLoginSrc} />
                    ) : getCookie("signUpChannel") === "400" ? (
                      <img src={KakaoLoginSrc} />
                    ) : (
                      <img src={AppleLoginSrc} />
                    )}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    alignSelf: "stretch",
                  }}>
                  <div
                    style={{
                      color: "#888",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                    }}>
                    휴대폰번호
                  </div>
                  <div
                    style={{
                      color: "#333",
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                    }}>
                    {stringToTelNo(userinfo.userPhone)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {setCookieBtn && (
            <Checkbox style={{ paddingBottom: "24px" }}>
              <CheckIcon
                type="checkbox"
                style={{ border: "0px" }}
                onClick={() => setToggle(!toggle)}
              />
              더 이상 보이지 않기
            </Checkbox>
          )}

          <div className="tbns-area">
            {handleCancelCBText != null && (
              <a
                href={void 0}
                className="btn-round gray"
                onClick={handleCancelCB}>
                {handleCancelCBText}
              </a>
            )}
            <a
              href={void 0}
              className="btn-round wht"
              id="targetLogout"
              onClick={handleConfirmCB}>
              {handleConfirmCBText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// 취소/확인 다이얼로그 ]]

// 로그아웃 alert [[
export const NewAlertLogout = props => {
  const { phonecfg, dispatch, userinfo, cfg } = useContext(AppContext);
  const { logoutView, setLogoutView } = props;

  const handleLogoutCancelCB = () => {
    closeLayerFn($("#confirm-layer"));
  };

  const handleLogoutConfirmCB = () => {
    loginLogInterface(
      userinfo,
      phonecfg,
      cfg,
      "O",
      "M",
      getCookie("signUpChannel")
    );
    dispatch({ type: LOG_OUT_SUCCESS });
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "out",
      userToken: "",
    });
    _O.Open("/membership/login");
  };

  return (
    <Fragment>
      {logoutView && (
        <Layer
          title="로그아웃 확인"
          desc={["정말 로그아웃 하시겠어요?"]}
          ps=""
          button={[
            {
              severity: "light",
              disable: "off",
              small: false,
              clickEvent: () => {
                setLogoutView(false);
              },
              text: "아니오",
            },
            {
              severity: "primary",
              disable: "off",
              small: false,
              clickEvent: () => {
                handleLogoutConfirmCB();
              },
              text: "로그아웃",
            },
          ]}
        />
      )}
    </Fragment>
  );
};

export const AlertLogout = props => {
  const { phonecfg, dispatch, userinfo, cfg } = useContext(AppContext);
  const { priv } = props;
  // _O.OpenMenu("/membership/login/4");

  const goToLogin = () => {
    loginLogInterface(
      userinfo,
      phonecfg,
      cfg,
      "O",
      "A",
      getCookie("signUpChannel")
    );
    dispatch({ type: LOG_OUT_SUCCESS });
    allCookieClear();
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "out",
      userToken: "",
    });
    _O.OpenMenu("/membership/login");
  };

  return (
    <div className="blacklayer-container alert-layer-logout">
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          {/* <div className="blgr-title">{title}</div> */}

          <div className="save-question-box">
            <span className="utt">
              <div>
                다른 기기에 로그인 되어있습니다. <br />
                다시 로그인 하십시오
              </div>
            </span>
          </div>

          <div className="tbns-area">
            <a className="btn-round wht" onClick={() => goToLogin()}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

// 고그아웃 alert]]

// 통신실패 alert [[
export const CnntFailLayout = props => {
  const { phonecfg } = useContext(AppContext);

  const { priv } = props;
  // _O.OpenMenu("/membership/login/4");
  const close = () => {
    closeLayerFn($(".alert-layer-cnntFail"));
  };

  return (
    <div className="blacklayer-container alert-layer-cnntFail">
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          {/* <div className="blgr-title">{title}</div> */}

          <div className="save-question-box">
            <span className="utt">
              <div>
                통신연결상태가 불안정합니다. <br />
                WiFi 또는 모바일데이터 기능을 켜고 앱을 재시작해 주십시요.
              </div>
            </span>
          </div>

          <div className="tbns-area">
            {/* <a className="btn-round wht" onClick={()=>_O.OpenMenu("/membership/login")}>확인</a> */}
            {phonecfg.phoneOS === "ANDROID"
              ? parseInt(phonecfg.version.split(".")[2]) >= 34 && (
                  <a
                    className="btn-round wht"
                    onClick={() => NativeAction(phonecfg, "appExit", "")}>
                    확인
                  </a>
                )
              : parseInt(phonecfg.version.split(".")[2]) >= 13 && (
                  <a
                    className="btn-round wht"
                    onClick={() => NativeAction(phonecfg, "appExit", "")}>
                    확인
                  </a>
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

// 자동 로그인 실패

export const AutoLoginFailLayout = props => {
  const { phonecfg, dispatch } = useContext(AppContext);

  const { priv, setLoginCnt } = props;
  // _O.OpenMenu("/membership/login/4");
  const close = () => {
    closeLayerFn($(".alert-layer-loginFail"));
  };

  // 로그인 재시도
  const loginCntReset = () => {
    setLoginCnt(0);
  };

  // 로그인 페이지 이동
  const goToLogin = () => {
    dispatch({ type: LOG_OUT_SUCCESS });
    allCookieClear();
    socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
      login: "out",
      userToken: "",
    });
    _O.OpenMenu("/membership/login");
  };

  return (
    <div className="blacklayer-container alert-layer-loginFail">
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          {/* <div className="blgr-title">{title}</div> */}

          <div className="save-question-box">
            <span className="utt">
              <div>
                로그인 정보를 불러올 수 없습니다.
                <br />
                다시 로그인 하시겠습니까?
              </div>
            </span>
          </div>

          <div className="tbns-area">
            <a className="btn-round wht" onClick={() => loginCntReset()}>
              재시도
            </a>
            <a className="btn-round wht" onClick={() => goToLogin()}>
              확인
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AlertTelLayer = memo(({ priv, tel }) => {
  const call = tel => {
    location.href = "tel:" + tel;
  };

  return (
    <div
      className="blacklayer-container alert-tel-layer"
      style={{ zIndex: "55" }}>
      <div className="bl-blind" />
      <div className="in-layerarea nobtn">
        <div
          className={
            priv === undefined
              ? "blgrn-box vertical"
              : "blgrn-box vertical " + priv
          }>
          <div className="blgr-title"></div>

          <div className="save-question-box">
            <span className="utt">
              <div>
                예약을 취소하려면 병원에 문의하세요.
                <br />
                tel : {stringToTelNo(tel)}
              </div>
            </span>
          </div>

          <div className="tbns-area">
            <a
              className="btn-round gray"
              onClick={() => closeLayerFn($(".alert-tel-layer"))}>
              닫기
            </a>
            <a className="btn-round wht" onClick={() => call(tel)}>
              전화걸기
            </a>
          </div>
        </div>
      </div>
    </div>
  );
});
